import React from "react";
import { Modal, Button } from "react-bootstrap";

const DocModal = ({ show, onHide, title, content }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title || "Document"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>  
        <p>{content || "No content available."}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DocModal;
